<template>
  <b-row class="d-flex justify-content-center align-items-center h-100-vh">
    <b-col sm="8" md="6" lg="4">
      <div class="text-center mb-4">
        <img src="/assets/images/logo-web.png" style="max-width: 260px !important;" alt="">
      </div>
      <b-card>
        <div class="flex-between-center">
          <ValidationObserver v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(onSubmit)">
              <form-group-input placeholder="Email anda" :need-label="false" label="Email" v-model="model.username" rules="required" id="username" />
              <div class="mt-3 w-100"></div>
              <form-group-input placeholder="Password anda" :need-label="false" label="Password" v-model="model.password" rules="required" type="password" id="password" />
              <b-alert v-if="errorMessage" variant="danger" show class="mt-3 mb-0">{{ errorMessage }}</b-alert>
              <!-- <b-row class="flex-between-center">
                <b-col cols="auto">
                  <a class="fs--1" href="#">Forgot Password?</a>
                </b-col>
              </b-row> -->
              <div>
                <b-button type="submit" :disabled="isLoading" variant="primary" block class="w-100 mt-3"><font-awesome-icon icon="spinner" spin v-if="isLoading"></font-awesome-icon> Masuk</b-button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import FormGroupInput from '@/components/FormGroupInput.vue';
export default {
  components: {
    FormGroupInput
  },
  data () {
    return {
      isLoading: false,
      errorMessage: '',
      model: {
        username: null,
        password: null
      }
    }
  },
  methods: {
    onSubmit () {
      if (this.isLoading) {
        return false
      }
      this.isLoading = true
      this.errorMessage = ''
      this.$store.dispatch('account/login', {
        username: this.model.username,
        password: this.model.password
      }).then(() => {
        // this.$store.dispatch('notification/welcome', this.$store.getters['account/accountData'].firstName)
        this.isLoading = false
        this.$router.push(this.$route.query.redirect !== undefined && !this.$route.query.redirect.includes('logout') ? this.$route.query.redirect : '/sales').then(() => {
          // location.reload()
        })
      }).catch(error => {
        this.isLoading = false
        const status = error && error.response ? error.response.status : null
        this.errorMessage = !status ? 'Server tidak dapat dihubungi. Silakan coba lagi.' : (status === 401 ? 'Kombinasi email dan password salah.' : 'Login gagal. Silakan coba lagi.')
        this.$store.dispatch('notification/error', this.errorMessage)
      })
    }
  }
}
</script>
